import React from "react";
import { all } from "ramda";
import { useIntl, FormattedMessage } from "react-intl";
import { Button, Box, Text, Flex } from "@chakra-ui/react";

import { CheckIcon } from "components/Icons";
import { isItemUnselected } from "../utils";

/**
 * <TransactionFilters /> Displays list of clickable filters.
 * @param {Array<SelectableTransactionFilter>} props.filters
 * @param {(name: string) => void} props.select
 * @returns {React.ReactElement}
 */
export default function TransactionFilters({ filters, onSelect }) {
  const { formatMessage } = useIntl();
  const isAllSelected = all(isItemUnselected, filters);

  const translateLabel = (labelToken) => {
    switch (labelToken) {
      case "purchase": {
        return formatMessage({
          defaultMessage: "Purchase",
          description: "Filter label",
        });
      }
      case "sale": {
        return formatMessage({
          defaultMessage: "Sale",
          description: "Filter label",
        });
      }
      case "token_purchase": {
        return formatMessage({
          defaultMessage: "Token Purchase",
          description: "Filter label",
        });
      }
      case "token_convert": {
        return formatMessage({
          defaultMessage: "Token Convert",
          description: "Filter label",
        });
      }
      case "payout": {
        return formatMessage({
          defaultMessage: "Payout",
          description: "Filter label",
        });
      }
      case "refund": {
        return formatMessage({
          defaultMessage: "Refund",
          description: "Filter label",
        });
      }
      case "deposit": {
        return formatMessage({
          defaultMessage: "Deposit",
          description: "Filter label",
        });
      }
      case "balance_transfer": {
        return formatMessage({
          defaultMessage: "Balance Transfer",
          description: "Filter label",
        });
      }
      default:
        return "";
    }
  };

  return (
    <Box data-testid="filter-buttons-container">
      <Button
        aria-label="All filter"
        key="all"
        variant={isAllSelected ? "solid" : "outline"}
        height="28px"
        fontSize="14px"
        fontWeight="600"
        paddingLeft="22px"
        paddingRight="22px"
        borderRadius={20}
        marginRight={1}
        marginBottom={1}
        onClick={() => {
          onSelect("all");
        }}
      >
        <Flex justifyContent="center">
          {isAllSelected && (
            <Flex alignItems="center" height="18px" position="absolute" left="6px">
              <CheckIcon size={0.6} />
            </Flex>
          )}
          <Text>
            <FormattedMessage defaultMessage="All" description="Filter label button" />
          </Text>
        </Flex>
      </Button>
      {filters.map(({ value, label, selected }) => {
        return (
          <Button
            aria-label={`${label} filter`}
            key={value}
            variant={selected ? "solid" : "outline"}
            height="28px"
            fontSize="14px"
            paddingLeft="22px"
            paddingRight="22px"
            fontWeight="600"
            borderRadius={20}
            marginRight={1}
            marginBottom={1}
            onClick={() => {
              onSelect(value);
            }}
          >
            <Flex justifyContent="center">
              {selected && (
                <Flex alignItems="center" height="18px" position="absolute" left="6px">
                  <CheckIcon size={0.6} />
                </Flex>
              )}
              <Text>{translateLabel(label)}</Text>
            </Flex>
          </Button>
        );
      })}
    </Box>
  );
}
